<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Кредиты по обучающимся</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-dropdown variant="success" v-if="isUniversityManager()">
          <template #button-content>
            Импортировать данные <b-icon-caret-down />
          </template>
          <b-dropdown-item @click="onClickImport()">
            Импортировать данные
          </b-dropdown-item>
          <b-dropdown-item @click="onClickDownloadTemplate">
            Выгрузить шаблон
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по ИИН"
                       id="iin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>


          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

        <div v-if="isManagerFC()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="degree" class="form-label col-md-3">
              Академическая степень
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.degreeId" id="degree"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="degree in degrees" :key="degree.id"
                        :value="degree.id">
                  {{ degree.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="profession" class="form-label col-md-3">
              Специальность
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.profession"
                  :options="professions"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="professionCustomLabel"
                  track-by="code"
                  :close-on-select="true"
                  :allow-empty="true"
                  placeholder="Выберите Специальность"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="val => {
                      page.filter.professionCode = val?.code || null;
                      reloadList();
                    }"
              />
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-3">
              Курс
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.course" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isFirstCourse" class="form-label col-md-3">
              1 курс (новый прием)
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.isFirstCourse" id="isFirstCourse"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="deducted" class="form-label col-md-3">
              Отчислен
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.deducted" id="deducted"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                v-if="isManagerFC() || isUniversityManager()"
                :disabled="items.length === 0"
                @click="onClickExportStudents()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(studentId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('studentId')"
             :class="{'ascending': page.sort.studentId === 'ASC', 'descending': page.sort.studentId === 'DESC'}">
          studentId
        </div>
      </template>
      <template #head(iin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('iin')"
             :class="{'ascending': page.sort.iin === 'ASC', 'descending': page.sort.iin === 'DESC'}">
          ИИН
        </div>
      </template>
      <template #head(lastname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lastname')"
             :class="{'ascending': page.sort.lastname === 'ASC', 'descending': page.sort.lastname === 'DESC'}">
          Фамилия
        </div>
      </template>
      <template #head(firstname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('firstname')"
             :class="{'ascending': page.sort.firstname === 'ASC', 'descending': page.sort.firstname === 'DESC'}">
          Имя
        </div>
      </template>
      <template #head(patronymic)="data">
        <div class="sortable-container none"
             @click="onSortChanged('patronymic')"
             :class="{'ascending': page.sort.patronymic === 'ASC', 'descending': page.sort.patronymic === 'DESC'}">
          Отчество
        </div>
      </template>
      <template #head(profession)="data">
        <div class="sortable-container none"
             @click="onSortChanged('profession')"
             :class="{'ascending': page.sort.profession === 'ASC', 'descending': page.sort.profession === 'DESC'}">
          Специальность
        </div>
      </template>
      <template #head(credits)="data">
        <div class="sortable-container none"
             @click="onSortChanged('credits')"
             :class="{'ascending': page.sort.credits === 'ASC', 'descending': page.sort.credits === 'DESC'}">
          Кредиты
        </div>
      </template>


      <template #cell(studentId)="data">
        {{ data.item.studentId }}
      </template>
      <template #cell(iin)="data">
        {{ data.item.iin }}
      </template>
      <template #cell(lastname)="data">
        <a :href="`/student-credits/${data.item.uuid}`">
          {{ data.item.lastname }}
        </a>
      </template>
      <template #cell(firstname)="data">
        <a :href="`/student-credits/${data.item.uuid}`">
          {{ data.item.firstname }}
        </a>
      </template>
      <template #cell(patronymic)="data">
        <a :href="`/student-credits/${data.item.uuid}`">
          {{ data.item.patronymic }}
        </a>
      </template>
      <template #cell(profession)="data">
        {{ data.item.profession?.code }} {{ data.item.profession?.nameRu }}
      </template>
      <template #cell(credits)="data">
        {{ data.item.credits?.credits }}
      </template>
      <!-- totalCreditsGranted column (новая колонка) -->
      <template #cell(totalCreditsGranted)="data">
        {{ data.item.credits?.totalCreditsGranted ?? 0 }}
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Импорт кредитов" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Выберите файл с данными (*.xlsx)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".xlsx" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentCreditsService from "@/services/studentCreditsService";
import {showErrorNotify, showNotify, showSuccessNotify} from "@/utils/notificationUtils";
import degreeService from "@/services/degreeService";
import professionService from "@/services/professionService";
import settingsService from "@/services/settingsService";
import authService from "@/services/authService";
import universityService from "@/services/universityService";
import delegationService from "@/services/delegationService";
import xlsExportService from "@/services/xlsExportService";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import {saveAs} from "@/assets/FileSaver.min";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      uploadedFile: null,
      page: {
        filter: {
          search: null,
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          degreeId: null,
          professionCode: null,
          course: null,
          deducted: null,
          isFirstCourse: null
        },
        sort: {
          bin: null,
          nameRu: null,
          region: null,
          profession: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'studentId', label: 'studentId', sortable: true},
        {key: 'iin', label: 'ИИН', sortable: true},
        {key: 'lastname', label: 'Фамилия', sortable: true},
        {key: 'firstname', label: 'Имя', sortable: true},
        {key: 'patronymic', label: 'Отчество', sortable: true},
        {key: 'profession', label: 'Специальность', sortable: true},
        {key: 'credits', label: 'Кредиты', sortable: true},
        {key: 'totalCreditsGranted', label: 'Предоставленные кредиты', sortable: true},
      ],
      items: [],
      universities: [],
      degrees: [],
      professions: [],
      years: Array.from({length: 10}, (v, i) => 1 + i),
      year: new Date().getFullYear(),
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i)
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    async reloadList() {
      this.isLoading = true;
      const response = await studentCreditsService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async submitForm() {
      if (!this.uploadedFile) {
        showErrorNotify("Убедитесь, что все обязательные поля заполнены");
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadedFile);

        let resp = await studentCreditsService.uploadStudentCredits(formData);

        if (resp) {
          showNotify(resp.status, resp.description);
          this.reloadList();
          this.showModal = resp.status == 'SUCCESS';
        }


      } catch (error) {
        showErrorNotify("Ошибка при загрузке файла " + error);
      } finally {
        this.isLoading = false;
      }
    },
    onClickImport() {
      this.uploadedFile = null;
      this.showModal = true;
    },
    async downloadExcel(templateType) {
      this.isLoading = true;
      const response = await xlsExportService.exportStudentsCredits(templateType, this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    async onClickExportStudents() {
      await this.downloadExcel(TemplateTypeEnum.STUDENTS_CREDITS_XLSX);
    },
    async onClickDownloadTemplate() {
      await this.downloadExcel(TemplateTypeEnum.STUDENTS_CREDITS_TEMPLATE_XLSX);
    },
    initDegrees() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      degreeService.getAll(params)
          .then(response => {
            this.degrees = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initProfessions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      professionService.getAll(params)
          .then(response => {
            this.professions = response.list.sort((a, b) => a.code.localeCompare(b.code));
          });
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    professionCustomLabel(option) {
      return `${option.code} ${option.nameRu}`
    },
  },
  mounted() {
    this.initDegrees();
    this.initProfessions();
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

</style>
